import PropTypes from 'prop-types';
import React, { Component } from 'react';
import {isLinkActive} from 'utils/routeUtils';
import InsiderCta from 'modules/Common/containers/InsiderCta';
import LoginButton from 'modules/Common/containers/LoginButton';
import BetslipButton from 'modules/Common/containers/BetslipButton';
import {has} from 'utils/features';

require('./HeaderActions.scss');

export default class HeaderActions extends Component {

    constructor(props) {
        super(props)
        this.state = this.setCssClasses(props, {insiderCta: null})
    }

    componentDidMount() {
        this.setState(this.setInsiderStateItems(this.props, this.state))
    }

    componentWillReceiveProps(nextprops) {
        const state = this.setCssClasses(nextprops, this.state)
        this.setState({
            ...this.setInsiderStateItems(nextprops, state)
        })
    }

    setCssClasses(props, state = {}) {
        return {
            ...state,
            loggedInCss:        (props.loggedIn ? 'logged-in' : 'logged-out'),
            ctaBtnClasses:      (props.screenSize === 'mobile') ? '' : 'insider-button large-primary-button',
            insiderActiveClass: isLinkActive(props.router, {href: '/insider'}) ? 'active' : ''
        }
    }

    setInsiderStateItems(props, state) {
        const isMobile = props.screenSize === 'mobile'
        if( has('insider-benefits') && 
            (isMobile || (!props.loggedIn && !isMobile))
        ) {
           return {
                ...state,
                insiderCta: (<div className={`header-action insider-action new-flag ${state.loggedInCss} ${state.insiderActiveClass}`}>
                                <InsiderCta isMobile={isMobile} active={!!state.insiderActiveClass} ctaBtnClasses={state.ctaBtnClasses} />
                             </div>)
            }
        }
        return {...state, insiderCta: null} 
    }   

    render() {
        const cssClasses = [
            'header-actions',
            this.props.screenSize,
            this.state.loggedInCss
        ].join(' ') ;
        return (
            <div className={cssClasses}>
                { this.state.insiderCta }
                <div className={`header-action main-account-icon ${this.state.loggedInCss}`}>
                    <LoginButton device={this.props.screenSize} />
                </div>

                <BetslipButton />             
            </div>
        );
    }
}

HeaderActions.propTypes = {
    screenSize: PropTypes.string.isRequired, // desktop or mobile,
    loggedIn: PropTypes.bool.isRequired,
    router: PropTypes.object.isRequired
};


// WEBPACK FOOTER //
// ./modules/Common/components/HeaderActions.js